import React from 'react';
import { List } from 'immutable';

import {
  Paragraph,
} from '@uncinc/react-drupal-core';

import {
  Container,
  Button,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  AnchorLinks,
  BreadcrumbsFromMenu,
  FadeWrapper,
  Hero,
  WysiwygField,
} from '../../../components';

import './style.scss';

const ALLOWED_WIDE_PARAGRAPHS = [
  'link_list',
];

const NodeParagraphPage = ({ entity, className }) => {
  const paragraphsPage = entity.toJS();

  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['body', 0, 'processed'], '');
  const summary = entity.getIn(['body', 0, 'summary'], '');
  const image = entity.getIn(['field_media_item', 0]);
  const imageTitle = entity.getIn(['field_media_item', 0, 'entity', 'field_caption', 0, 'value'], null);

  const anchorLinks = paragraphsPage.field_anchor_links;
  const paragraphs = paragraphsPage.field_paragraphs;

  const link = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkTitle = entity.getIn(['field_link', 0, 'title']);
  const linkTarget = entity.getIn(['field_link', 0, 'options', 'attributes', 'target'], '_self');

  return (
    <article className="NodeParagraphPage">
      <Container>
        <div className="row">
          <div className="col-12">
            <BreadcrumbsFromMenu />
          </div>
        </div>
      </Container>
      {/* Start of Preface */}
      <Container>
        <div className="row">
          <div className="col-12 col-md-10 offset-md-1">
            <div className="Preface">
              <FadeWrapper>
                <div className="Preface__title">
                  <h1>{title}</h1>
                </div>
              </FadeWrapper>
              <div className="Preface__body">
                <FadeWrapper delay={100}>
                  <WysiwygField
                    property="schema:text"
                    html={summary}
                  />
                </FadeWrapper>
              </div>
              {link && linkTitle && (
                <FadeWrapper delay={200}>
                  <div className="Preface__link">
                    <Button
                      href={link}
                      target={linkTarget}
                      className="Button--cta"
                    >
                      {linkTitle}
                    </Button>
                  </div>
                </FadeWrapper>
              )}
            </div>
          </div>
        </div>
      </Container>
      {/* End of Preface */}

      {/* Start of Hero */}
      {image && (
        <Container>
          <div className="row">
            <div className="col-12">
              <Hero
                image={image}
                description={imageTitle}
              />
            </div>
          </div>
        </Container>
      )}
      {/* End of Hero */}

      {/* Start of AnchorLinks */}
      {anchorLinks.length > 0 && (
        <Container>
          <div className="row">
            <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
              <AnchorLinks
                anchorLinks={anchorLinks}
                paragraphs={paragraphs}
              />
            </div>
          </div>
        </Container>
      )}
      {/* End of AnchorLinks */}

      {/* Start of Body */}
      {body && (
        <Container>
          <div className="row">
            <div className="col-12 col-md-10 offset-md-1">
              <FadeWrapper delay={300}>
                <WysiwygField
                  className="NodeParagraphPage__hero__body"
                  property="schema:text"
                  html={body}
                />
              </FadeWrapper>
            </div>
          </div>
        </Container>
      )}
      {/* End of Body */}

      {/* Start of paragraphs */}
      {entity.get('field_paragraphs') ? (
        <div className="node--page--paragraphs-wrapper">
          {entity.get('field_paragraphs', List()).map((paragraph) => {
            const id = paragraph.get('target_id');
            const paragraphType = paragraph.getIn(['entity', 'type', 0, 'target_id']);

            return (
              <FadeWrapper key={`paragraph:${id}`}>
                <Paragraph
                  id={id}
                  entity={paragraph.get('entity')}
                  wide={ALLOWED_WIDE_PARAGRAPHS.includes(paragraphType)}
                />
              </FadeWrapper>
            );
          })}
        </div>
      ) : null}
      {/* End of paragraphs */}

    </article>
  );
};

export default NodeParagraphPage;
